
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelOfferMonthly',
    props: { claiming: { type: Boolean, default: false } },
    emits: ['claim', 'decline', 'stay'],
});
